// El escritor de prompts de IMAGEN del backend, suelto
// (`POST /v1/ads/escribir-prompt`) — ADR-2026-10-04-el-escritor-de-imagen-usa-las-reglas-del-agente.
//
// Redacta con las reglas del agente (`pages/v2/reglasDeImagen.ts`, copiadas al backend) y
// devuelve, además del prompt, lo que el agente DECLARA de cada imagen: la tarea y la piel
// (con eso el backend elige el motor), el fondo blanco y qué es cada foto subida (su
// etiqueta dispara el protocolo de ese rol). Sin generar ni cobrar. Sólo existe en el
// atlas-backend.

import { USE_ATLAS_BACKEND } from '../config';
import { atlasBackendFetch } from './atlasBackend';

export interface PromptEscritoDeImagen {
  prompt: string;
  tarea: 'crear' | 'editar' | 'componer' | 'explorar' | 'grafica';
  /** `conservar` | `fusionar` (ADR-2026-10-07-conservar-o-fusionar). */
  edicion: 'conservar' | 'fusionar';
  piel_expuesta: boolean;
  fondo_blanco: boolean;
  luz_fondo_blanco: 'difusa' | 'dura';
  /** Qué es cada foto subida, por el nombre con que se la menciona. */
  etiquetas: Array<{ mencion: string; etiqueta: string }>;
}

const TIMEOUT_MS = 130_000;

/** `body`: `prompt`, `Format` y `reference_images` (con `mencion`), como en la generación. */
export async function escribirPromptDeImagen(body: Record<string, unknown>): Promise<PromptEscritoDeImagen> {
  if (!USE_ATLAS_BACKEND) throw new Error('Mejorar el prompt no está disponible en este entorno.');
  let res: Response;
  try {
    res = await atlasBackendFetch('/v1/ads/escribir-prompt', body, { signal: AbortSignal.timeout(TIMEOUT_MS) });
  } catch (e: any) {
    if (e?.name === 'TimeoutError' || e?.name === 'AbortError') {
      throw new Error('Mejorar el prompt tardó demasiado. Probá de nuevo.');
    }
    throw new Error('No se pudo conectar. Revisá tu conexión.');
  }
  const data: any = await res.json().catch(() => null);
  if (!res.ok || typeof data?.prompt !== 'string' || !data.prompt.trim()) {
    throw new Error((typeof data?.error === 'string' && data.error) || 'No pudimos mejorar el prompt. Probá de nuevo.');
  }
  const tarea =
    data.tarea === 'editar' || data.tarea === 'componer' || data.tarea === 'explorar' || data.tarea === 'grafica'
      ? data.tarea : 'crear';
  return {
    prompt: data.prompt,
    tarea,
    edicion: data.edicion === 'fusionar' ? 'fusionar' : 'conservar',
    piel_expuesta: data.piel_expuesta === true,
    fondo_blanco: data.fondo_blanco === true,
    luz_fondo_blanco: data.luz_fondo_blanco === 'dura' ? 'dura' : 'difusa',
    etiquetas: Array.isArray(data.etiquetas)
      ? data.etiquetas.filter((e: any) => typeof e?.mencion === 'string' && typeof e?.etiqueta === 'string')
      : [],
  };
}
